import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../axios-orders";
import { GenerateOcRequest, GenerateOcResponse } from "../types";
import { queryKeys } from "./queryKeys";

const generateOc = async (
  body: GenerateOcRequest
): Promise<GenerateOcResponse> => {
  // The backend requires the `{ selections, coordinate }` wrapper — a bare array is a 400.
  const { data } = await axios.post("/purchase-orders", body);
  return data;
};

/** Generates one OC per selection (the backend splits by supplier/currency) as DRAFTs. */
export const useGenerateOc = () => {
  const queryClient = useQueryClient();
  return useMutation<GenerateOcResponse, Error, GenerateOcRequest>({
    mutationFn: generateOc,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.PURCHASE_ORDERS] });
      // The generated candidates are no longer awardable.
      queryClient.invalidateQueries({
        queryKey: [queryKeys.AWARDABLE_NEGOTIATIONS],
      });
      // New OCs change the per-status counts, so the summary tiles must refetch.
      queryClient.invalidateQueries({
        queryKey: [queryKeys.PURCHASE_ORDER_COUNTS],
      });
    },
  });
};
